import { render } from "./BarcodeGenerator.vue?vue&type=template&id=a6363290&ts=true"
import script from "./BarcodeGenerator.vue?vue&type=script&lang=ts"
export * from "./BarcodeGenerator.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__